import { create } from 'zustand';
import { DestinationTypes } from '../../app/[locale]/(cms)/CMSComponents/services/types';
import { devtools, persist } from 'zustand/middleware';

interface CmsStore {
  destinationValue: any | null;
  destination: DestinationTypes | null;
  updateDestinationValue: (destinationValue: any) => void;
  updateDestination: (destination: number) => void;
}

const useCmsStore = create<CmsStore>()(
  devtools(
    persist(
      (set) => ({
        destinationValue: null,
        destination: null,
        updateDestinationValue: (destinationValue: any) => set(() => ({ destinationValue })),
        updateDestination: (destination: number) => set(() => ({ destination })),
      }),
      {
        name: 'cms-store',
      },
    ),
  ),
);

export default useCmsStore;
